/**
 * 格式化时间戳
 * @param {number} time 时间戳
 * @param {string} format 时间格式化 eg: yyyy-MM-dd hh:mm:ss
 */
export const dateFormat = function(time, format = 'yyyy-MM-dd hh:mm:ss') {
  if (typeof time === 'undefined') return '';
  time = new Date(time);
  var o = {
    'M+': time.getMonth() + 1, //month
    'd+': time.getDate(), //day
    'h+': time.getHours(), //hour
    'm+': time.getMinutes(), //minute
    's+': time.getSeconds(), //second
    'q+': Math.floor((time.getMonth() + 3) / 3), //quarter
    S: time.getMilliseconds(), //millisecond
  };
  var week = [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六',
  ];
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (time.getFullYear() + '').substr(4 - RegExp.$1.length),
    );
  }
  if (/(w+)/.test(format)) {
    format = format.replace(RegExp.$1, week[time.getDay()]);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length),
      );
    }
  }
  return format;
};
export const resetT = function(time) {
  var T = new Date(time);
  var year = T.getFullYear();
  var month = T.getMonth() + 1;
  month = month < 10 ? '0' + month : month;
  var day = T.getDate();
  day = day < 10 ? '0' + day : day;
  return year + '-' + month + '-' + day;
};
